<div class="flex align-items-center justify-content-between flex-row w-full flex-wrap card bg-blue-200 py-4 px-4">
	<div class="flex font-semibold">{{ 'STATUS' | translate }}</div>
	<p-progressBar *ngIf="hasPercentageProgress()" [value]="deviceStatus.Percentage" [class]="dynamicWidth()"></p-progressBar>
	<p-progressBar *ngIf="!hasPercentageProgress()" value="0" [class]="dynamicWidth()"></p-progressBar>
	<div *ngIf="commandDescription" class="font-semibold">{{ commandDescription }}</div>
</div>
